import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import GlobalSearch from './components/GlobalSearch';
import NotificationBell from './components/NotificationBell';
import KeyboardShortcuts from './components/KeyboardShortcuts';

export default function Shell({ title, subtitle, actions, breadcrumb, children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand"><img src="/cnerzy-logo.png" alt="cnerzy" className="brand-logo" /><span>Rivet</span></div>
        <NavLink to="/mailbox" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>📬 Mailbox</NavLink>
        <NavLink to="/inbox" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>📋 RFQs</NavLink>
        <NavLink to="/suppliers" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>🏭 Suppliers</NavLink>
        <NavLink to="/customers" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>🏢 Customers</NavLink>
        <NavLink to="/dashboard" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>📊 Dashboard</NavLink>
        <NavLink to="/team" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>👥 Team</NavLink>
        <NavLink to="/settings/email-inbox" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>🔌 Email inbox</NavLink>
        <NavLink to="/settings" className={({ isActive }) => 'nav-item ' + (isActive ? 'active' : '')}>⚙️ Settings</NavLink>
        <div className="spacer" />
        <div className="user-card">
          <div className="name">{user?.name || 'Guest'}</div>
          <div>{user?.role}</div>
          <button className="btn btn-ghost btn-sm" style={{ marginTop: 8 }} onClick={() => { logout(); nav('/login'); }}>Sign out</button>
        </div>
      </aside>
      <div className="main">
        <div className="topbar">
          <div>
            <h1>{title}</h1>
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </div>
          <div className="spacer" />
          <GlobalSearch />
          <NotificationBell />
          {actions}
        </div>
        <KeyboardShortcuts />
        {breadcrumb && <div className="breadcrumb">{breadcrumb}</div>}
        <div className="content">{children}</div>
      </div>
    </div>
  );
}
